import SwapArrow from "../witadmin/icons/swapArrow";
import styled from "styled-components";
import { Card } from "react-bootstrap";

export const StyledSwapArrow = styled(SwapArrow)`
  height: 14px;
  width: 14px;
`;

export const StyledCard = styled(Card)`
  margin: 20px;
`;

export const Container = styled.span`
  input {
    width: 0;
  }
  .form-group {
    margin-bottom: 0;
  }
`;

export const WitLabel = styled.label`
  display: block;
  width: 100%;
  padding: 0;
  margin: 30px 0 20px 10px;
  font-size: 21px;
  line-height: inherit;
  color: #3a3f51;
  border: 0;
  border-bottom: 1px solid #e5e5e5;
`;

export const DisplayContentWrapper = styled.div`
  .translation-component {
    width: 100% !important;
  }
  .full-width {
    width: 100% !important;
    display: block;
  }
`;
export const ErrorField = styled.div`
  width: 100%;
  margin-top: 10px;
  background-color: #f5abba;
  border-radius: 5px;
  padding: 2px 5px;
  color: #6e0218;
`;

export const errorMessageBox = {
  backgroundColor: "#f8d7da",
  color: "#721c24",
  padding: "12px 20px",
  marginTop: "20px",
  borderRadius: "4px",
  border: "1px solid #f5c6cb",
};
